import { LAYERS } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";
import { useI18n } from "../i18n";

const THEMES = [
  { bg: "#EAF2FD", border: "#93C5FD", tag: "#1D4ED8", accent: "#2563EB" },
  { bg: "#F0FDF4", border: "#86EFAC", tag: "#15803D", accent: "#16A34A" },
  { bg: "#FFF7ED", border: "#FDBA74", tag: "#C2410C", accent: "#EA580C" },
];

export default function Ecosystem() {
  const { tr } = useI18n();
  return (
    <section id="ecosystem" data-testid="ecosystem-section" className="py-24 lg:py-32 bg-[#F6FAFF] border-y wp-rule">
      <SectionHead
        index="§ 02"
        eyebrow="Three-Layer Architecture"
        title="The WHERE, the WHO and the WHAT — cleanly separated."
        sub="WorldPulse owns place. SocialPulse owns identity. Vertical platforms own their subjects. Shared IDs and APIs instead of isolated copies."
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 grid md:grid-cols-3 gap-6">
        {LAYERS.map((layer, i) => {
          const t = THEMES[i];
          return (
            <Reveal key={layer.id} delay={i * 0.12}>
              <div
                data-testid={`ecosystem-layer-${i + 1}`}
                className="wp-lift border rounded-3xl p-8 h-full flex flex-col"
                style={{ background: t.bg, borderColor: t.border }}
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono-wp text-[0.6rem] uppercase tracking-[0.25em]" style={{ color: t.tag }}>{tr(layer.tag)}</span>
                  <span className="font-atlas italic text-2xl" style={{ color: t.accent }}>{tr(layer.q)}</span>
                </div>
                <h3 className="font-atlas text-3xl mt-6 text-[#0F2557]">{layer.name}</h3>
                <p className="text-sm mt-4 leading-relaxed text-[#4A5568]">{tr(layer.desc)}</p>
                <div className="atlas-dash my-6" />
                <ul className="space-y-3 mt-auto">
                  {layer.items.map((item) => (
                    <li key={item} className="text-xs font-mono-wp flex gap-3 text-[#4A5568]">
                      <span style={{ color: t.accent }}>—</span>{tr(item)}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
